import React from "react";
import "./index.less";
interface IProps {
  title: string;
  styles?: any;
}

const HeadTitle = (props: IProps) => {
  const { title } = props;
  return (
    <div className="theme-header">
      <h3 className="title">{title}</h3>
    </div>
  );
};

export default HeadTitle;
